import axios from '../helpers/axios';
import type { AppThunk, Notify } from '../typings/redux';
import { getTranslationKey } from '../modules/utils';

export const getMSGroups = (): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const res = await axios.get('/api/mailsuite/api/get?query=groups.json');
    if (res.status === 200) dispatch({ type: 'set_ms_groups', payload: res.data });
  } catch (e) {
    console.log(e);
  }
};

export const getMSForms =
  (list_id: string): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      if (list_id !== '-1') {
        const res = await axios.get(`/api/mailsuite/api/get?query=groups.json/${list_id}/forms`);
        if (res.status === 200) dispatch({ type: 'set_ms_forms', payload: res.data });
      }
    } catch (e) {
      console.log(e);
    }
  };

export const getMSForm =
  (form_id: string): AppThunk<Promise<string>> =>
  async () => {
    try {
      if (form_id !== '-1') {
        const res = await axios.get('/api/mailsuite/api/get', {
          params: {
            query: `forms.json/${form_id}/code`,
            data: { badget: false, embedded: true, ssl: true }
          }
        });

        return res.data;
      }

      return `<p>${getTranslationKey('mailsuite.formNotFound')}</p>`;
    } catch (e) {
      return `<p>${getTranslationKey('mailsuite.formNotFound')}</p>`;
    }
  };

export const createCleverreachAccount =
  (notify: Notify): AppThunk<Promise<void>> =>
  async () => {
    try {
      if (window.confirm(getTranslationKey('mailsuite.rlyCreateAccount'))) {
        await axios.get('/api/mailsuite/api/createUserAccount');
        notify({
          title: getTranslationKey('success'),
          message: getTranslationKey('mailsuite.accountCreated'),
          status: 'success',
          position: 'top-center',
          dismissible: true,
          dismissAfter: 7500
        });
      }
    } catch (e) {
      notify({
        title: getTranslationKey('error'),
        message: getTranslationKey('generalError'),
        status: 'error',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 7500
      });
      console.log(e);
    }
  };
